(function () {
    'ngInject';

    angular.module('app.shared.services').factory('AuthService', authService);

    function authService($rootScope, $q, $location, UsersAPIService, TokenAPIService, ConfigService) {
        let returnPath = null;
        $rootScope.isManagedUser = false;
        $rootScope.childRestrictedAccess = false;

        function isCollectiveRetailUser() {
            return $rootScope.user?.AccessRoles?.Serialized?.split(',')?.includes('collective-retail') === true;
        }

        function isRouteAllowed(path) {
            // Collective retail users can only access store and account sections
            if ($rootScope.user && isCollectiveRetailUser()) {
                return (
                    path === '/signin' ||
                    path === '/invalidStore' ||
                    path === '/account' ||
                    path === '/store' ||
                    path.startsWith('/store/')
                );
            }

            // Disabled users can only access /home and /account, unless where are accessing them from
            //  and admin user
            if (
                $rootScope.user &&
                !$rootScope.user.ImpersonatedFromAdminUser &&
                $rootScope.user.IsDisabled &&
                path !== '/account' &&
                path !== '/home' &&
                path !== '/signin'
            ) {
                return false;
            }
            return true;
        }

        function isEffectiveAdmin(user) {
            // Child users impersonating never get admin privileges, even if parent is admin
            if (user?.ImpersonatedFromChildUser) {
                return false;
            }
            return (
                user?.AccessRoles?.Serialized?.split(',')?.includes('admin') === true ||
                user?.ImpersonatedFromAdminUser ||
                false
            );
        }

        function passwordLogin(username, password) {
            return $q((resolve, reject) => {
                TokenAPIService.getPasswordToken(username, password)
                    .then((data) => {
                        $rootScope.$broadcast('user:signin');
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }

        async function getSession() {
            try {
                if ($rootScope.user == undefined) {
                    const response = await UsersAPIService.getMe();
                    $rootScope.$broadcast('userChanged', response);
                    $rootScope.user = response;
                }
                const user = $rootScope.user;
                const roles = $rootScope.user.AccessRoles.Serialized.split(',');

                if ($rootScope.hasShStores == undefined) {
                    const { hasShStores, displayOrderManager, hasWooAutoBilling } = await UsersAPIService.getStoresPlan(
                        user
                    );
                    $rootScope.hasShStores = hasShStores;
                    $rootScope.displayOrderManager = displayOrderManager;
                    $rootScope.hasWooAutoBilling = hasWooAutoBilling;
                }

                if ($rootScope.storesWithDebt == undefined) {
                    $rootScope.storesWithDebt = [];
                    const hasFees = user.Stores.some(
                        (store) => store.Type == 3 || store.Type == 8 || store.Type == 255 || store.Type == 11
                    );
                    if (hasFees) {
                        const storesWithDebt = await UsersAPIService.getStoresWithDebt();

                        for (const store of storesWithDebt) {
                            const isPastDue = store.InvoiceStatus == 3;
                            const isUnpaid = store.InvoiceStatus == 4;
                            let storeToUpdateBilling;
                            if (isPastDue) {
                                //Store(s) weren't disabled yet
                                storeToUpdateBilling = user.Stores.find(
                                    (s) => s.Type == store.StoreType && s.HasBilling && !s.Disabled
                                );
                            } else if (isUnpaid) {
                                //Store(s) were disabled due transaction fees unpaid
                                storeToUpdateBilling = user.Stores.find(
                                    (s) =>
                                        s.Type == store.StoreType &&
                                        s.HasBilling &&
                                        s.Disabled &&
                                        s.TransactionFeesUnpaid
                                );
                            }
                            store.storeToUpdateBilling = storeToUpdateBilling ? storeToUpdateBilling.Url : null;
                        }
                        $rootScope.storesWithDebt = storesWithDebt;
                    }
                }

                if ($rootScope.enableGroups == undefined) {
                    // Only enable groups for users with the proper role or new shopify plans
                    $rootScope.enableGroups = true;
                }

                if ($rootScope.isAffiliateUser == undefined) {
                    $rootScope.isAffiliateUser = roles.includes('affiliate');
                }

                $rootScope.isCollectiveRetailUser = roles.includes('collective-retail');

                if ($rootScope.isPodUser == undefined) {
                    $rootScope.isPodUser = roles.includes('external-pod');
                }

                $rootScope.navTemplateShow = true;
                if ($rootScope.isAffiliateUser && roles.length == 1) {
                    $rootScope.navTemplateShow = false;
                }

                if (!user) return;

                $rootScope.isManagedUser = roles.includes('managed');
                if ($rootScope.isManagedUser) {
                    const parentAccessRoles = user.User_Id ? await UsersAPIService.getParentAccessRoles() : '';
                    if (parentAccessRoles && parentAccessRoles.split(',').includes('restricts-children')) {
                        $rootScope.childRestrictedAccess = true;
                    }
                }

                return user;
            } catch (_) {
                return null;
            }
        }

        function logout() {
            return $q((resolve, reject) => {
                UsersAPIService.logout()
                    .then(() => {
                        $rootScope.isManagedUser = false;
                        $rootScope.childRestrictedAccess = false;
                        // Clear the global user and notify listeners so UI can react immediately
                        $rootScope.user = null;
                        try {
                            $rootScope.$broadcast('userChanged', null);
                        } catch (e) {
                            // ignore
                        }
                        // Also dispatch a DOM event for non-Angular listeners (e.g., Vue components)
                        try {
                            window.dispatchEvent(new CustomEvent('customily:user-changed', { detail: null }));
                        } catch (e) {
                            // ignore
                        }
                        $location.path('/signin');
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }

        function setSignInReturnPath(path) {
            if (!ConfigService.openRoutes.includes(path)) {
                returnPath = path;
            }
        }

        function getSignInReturnPath() {
            return returnPath;
        }

        return {
            passwordLogin: passwordLogin,
            getSession: getSession,
            logout: logout,
            setSignInReturnPath: setSignInReturnPath,
            getSignInReturnPath: getSignInReturnPath,
            isRouteAllowed: isRouteAllowed,
            isEffectiveAdmin: isEffectiveAdmin,
            isCollectiveRetailUser: isCollectiveRetailUser
        };
    }
})();
